// uses ./mainLayout.less
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Notification from '../notification/Notification';
import NavBar from './navBar/NavBar';
/* eslint-disable-next-line import/no-named-as-default */
import AppStatusForm from '../appStatusForm/AppStatusForm';
import { ExtendedRootState } from '../common/interfaces';

const MainLayout = ({ children, isAdmin }: { children: any; isAdmin: boolean }) => {
    const childWrapperClass = classNames('layout-child-wrapper', { 'layout-child-wrapper-full': !isAdmin });
    const adminNavBar = isAdmin ? <NavBar /> : null;

    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            const clickedText = target.title || target.innerText || target.getAttribute('aria-label') || 'unknown';

            try {
                window.parent.postMessage(
                    {
                        type: 'iframe_click',
                        label: clickedText,
                    },
                    'https://stage.qa-egnyte.com' || 'https://www.egnyte.com'
                );
            } catch (error) {
                // To prevent app disruption
            }
        };

        document.addEventListener('click', handleClick);

        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);

    return (
        <div className="main-layout">
            {adminNavBar}
            <div className={childWrapperClass}>{children}</div>
            <AppStatusForm />
            <Notification />
        </div>
    );
};

const mapStateToProps = (state: ExtendedRootState) => ({
    isAdmin: state.user.isAdmin,
});

export default connect(mapStateToProps)(MainLayout);
